enum TireMakeOption {
  OTHER = 'Other',
}

export default TireMakeOption;